import {
    FETCH_PUBLICEXPOSUREASSETS_BEGIN,
    FETCH_PUBLICEXPOSUREASSETS_SUCCESS,
    FETCH_PUBLICEXPOSUREASSETS_FAILURE, 
    FETCH_PUBLICEXPOSUREMINMAXDATES_BEGIN,
    FETCH_PUBLICEXPOSUREMINMAXDATES_SUCCESS,
    FETCH_PUBLICEXPOSUREMINMAXDATES_FAILURE,
    FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_BEGIN,
    FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_SUCCESS,
    FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_FAILURE,

    FETCH_PUBLICEXPOSURETSCHART_BEGIN,
    FETCH_PUBLICEXPOSURETSCHART_FAILURE,
    FETCH_PUBLICEXPOSUREEQUITYCHART_SUCCESS,
    FETCH_PUBLICEXPOSURECURRENTSECTORCHART_SUCCESS,
    FETCH_PUBLICEXPOSURESECTORNOOPCHART_SUCCESS,
    FETCH_PUBLICEXPOSURESECTORCHART_SUCCESS,
    FETCH_GETOVERLAPASSET_BEGIN,
    FETCH_GETOVERLAPASSET_SUCCESS,
    FETCH_GETOVERLAPASSET_FAILURE

    
    } from '../constants/publicExposure';

const initialState={
    PublicExposureAssetsList:{},
    MinMaxAssetDates:{},
    OverlapAnalysisReportData: [],
    OverlapAnalysisLoading:false,
    EquityChart: {},
    CurrentSectorChart: {},
    SectorNoOpChart: {},
    SectorChart: {},
    AssetsforUniverse: {},
    error:""
}


export const getPublicExposureReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {       
    case FETCH_PUBLICEXPOSUREASSETS_BEGIN: 
        return {
          ...state,
          isLoading: true,
          error: null,
        };
    case FETCH_PUBLICEXPOSUREASSETS_FAILURE:
        return {
            ...state,
            isLoading:true,
            error:payload.error
        };
    case FETCH_PUBLICEXPOSUREASSETS_SUCCESS:
        return {
            ...state,
            isLoading:false,
            PublicExposureAssetsList:payload.PublicExposureAssetsList
        };
    case FETCH_PUBLICEXPOSUREMINMAXDATES_BEGIN: 
    return {
        ...state,
        isLoading: true,
        error: null,
    };
    case FETCH_PUBLICEXPOSUREMINMAXDATES_FAILURE:
        return {
            ...state,
            isLoading:true,
            error:payload.error
        };
    case FETCH_PUBLICEXPOSUREMINMAXDATES_SUCCESS:
        return {
            ...state,
            isLoading:false,
            MinMaxAssetDates:payload.MinMaxAssetDates
        };
    case FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_BEGIN: 
    return {
        ...state,
        isLoading: true,
        error: null,
        OverlapAnalysisLoading:true
    };
    case FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_FAILURE:
        return {
            ...state,
            isLoading:true,
            error:payload.error,
            OverlapAnalysisLoading:false
        };
    case FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_SUCCESS:
        return {
            ...state,
            isLoading:false,
            OverlapAnalysisReportData:payload.OverlapAnalysisReportData,
            OverlapAnalysisLoading:false
         };

     case FETCH_PUBLICEXPOSURETSCHART_BEGIN:
         return {
             ...state,
             isLoading: true,
             error: null,
         };
     case FETCH_PUBLICEXPOSURETSCHART_FAILURE:
         return {
             ...state,
             isLoading: true,
             error: payload.error
         };
     case FETCH_PUBLICEXPOSUREEQUITYCHART_SUCCESS:
         return {
             ...state,
             isLoading: false,
             EquityChart: payload.EquityChart
         };
     
     case FETCH_PUBLICEXPOSURECURRENTSECTORCHART_SUCCESS:
         return {
             ...state,
             isLoading: false,
             CurrentSectorChart: payload.CurrentSectorChart
         };
     case FETCH_PUBLICEXPOSURESECTORNOOPCHART_SUCCESS:
         return {
             ...state,
             isLoading: false,
             SectorNoOpChart: payload.SectorNoOpChart
         };
     case FETCH_PUBLICEXPOSURESECTORCHART_SUCCESS:
         return {
             ...state,
             isLoading: false,
             SectorChart: payload.SectorChart
         };

     case FETCH_GETOVERLAPASSET_BEGIN:
         return {
             ...state,
             isLoading: true,
             error: null,
         };
     case FETCH_GETOVERLAPASSET_FAILURE:
         return {
             ...state,
             isLoading: true,
             error: payload.error
         };
     case FETCH_GETOVERLAPASSET_SUCCESS:
         return {
             ...state,
             isLoading: false,
             AssetsforUniverse: payload.AssetsforUniverse
         };


    default:
        return state;
 }
}

export default getPublicExposureReducer
